import { camelCaseToTitle } from '../../../../helpers/StringHelper';

export const defaultData = {};

export const mapData = (data, metricsValues = []) => {
  const metrics = [...metricsValues];
  metrics.reverse();
  const all = [];
  const toggledKeys = metrics.filter((s) => s.toggled).map((s) => s.key);
  const _keys = Object.keys(data);
  _keys.forEach((k, i) => {
    const values = Object.entries(data[k]);
    if (values.length) {
      if (i === 0) {
        values.forEach(([K, v]) => {
          if (toggledKeys.includes(K)) {
            all.push({ type: `W${camelCaseToTitle(k)}_`, value: v, series: K });
          }
        });
      }
      values.forEach(([K, v]) => {
        if (toggledKeys.includes(K)) {
          all.push({ type: k, value: v, series: K });
        }
      });
      if (i === _keys.length - 1) {
        values.forEach(([K, v]) => {
          if (toggledKeys.includes(K)) {
            all.push({ type: `_W${camelCaseToTitle(k)}_`, value: v, series: K });
          }
        });
      }
    } else {
      if (i === 0) {
        toggledKeys.forEach((tK) => {
          all.push({ type: `W${camelCaseToTitle(k)}_`, value: 0, series: tK });
        });
      }

      toggledKeys.forEach((tK) => {
        all.push({ type: k, value: 0, series: tK });
      });

      if (i === _keys.length - 1) {
        toggledKeys.forEach((tK) => {
          all.push({ type: `W${camelCaseToTitle(k)}_`, value: 0, series: tK });
        });
      }
    }
  });
  return all;
};

export const Tooltip = (data, t) => {
  if (data) {
    const allValues = data.map((d) => d.value);
    let sum = 0;

    allValues.forEach((v) => {
      sum += parseInt(v) || 0;
    });

    const items = data.map((d) => {
      return `
      <div class="item">
        <div class="cont">
          <div class="legend" style="background: ${d.color}"></div>
        </div>
        <div class="cont label">
          <label>${t(camelCaseToTitle(d.name))}</label>
        </div>
        <div class="cont value">
          <label>${d.value}</label>
        </div>
      </div>
    `;
    });

    return `
      <div class="sca-graph-tooltip">
        <div class="tooltip-header">
          <h3>
          ${t('Version')} ${data[0] && typeof data[0].title === 'string' ?
        data[0].title.includes('W') ? data[0].title.split('W')[1] : data[0].title : ''}
          </h3>
          <h4>${sum} ${t('Challenges')}</h4>
        </div>
        <div class="items">
          ${items.join('')}  
        </div>
      </div>
    `;
  }
  return '';
};
